module.exports = __webpack_public_path__ + "img/acquisitions-incorporated.50931f72.svg";